import React, { useState, useEffect } from 'react';
import { storage, db } from '../../app-firebase/firebase';
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';
import { saveCart } from '../util/localStorage';
import AddedToCartMessage from '../util/AddedToCartMessage';

import './new-product.scss';

const NewProduct = props => {

   const [img, setImg] = useState('');
   const [wasAdded, setWasAdded] = useState(false)

   useEffect(() => {
      storage.ref(props.product.image[0]).getDownloadURL().then(url => {
         setImg(url);
      })
      return () => {
         db.goOffline();
      }
   }, [props.product.image]);

   const handleAddToCart = (e, product) => {
      e.preventDefault();
      e.target.blur();
      saveCart(product);
      props.updateCartStorage();
      setWasAdded(true);
   }

   const link = '/products/' + props.product.ipNumber;
   const desc = props.product.description[0].length <= 400 ? props.product.description[0] + '...' : props.product.description[0].substring(0, 400) + '...';
   const priceCad = Number(props.product.priceCad);
   const priceUsd = Number(props.product.priceUsd);

   return (
      <div className="p-3 np-container" style={props.isLast ? {marginBottom:'3rem'} : {}}>
         <div className="d-flex">
            <div className="np-picture">
               {img ?
                  <Link to={link}>
                     <img src={img} alt={props.product.title} />
                  </Link> :
                  <div className="img-loading d-flex align-items-center justify-content-center">
                     <ReactLoading type="spin" color="#2D3142" />
                  </div>
               }
            </div>

            <div className="np-info1">
               <Link to={link}>
                  <h3>{props.product.title}</h3>
               </Link>
               <p className="hide-small">{desc} <span><Link to={link}>Check this product!</Link></span></p>
               <p className="for-small-devices hide-small">USD ${priceUsd.toFixed(2)}</p>
               <p className="for-small-devices hide-small">CAD ${priceCad.toFixed(2)}</p>
               <div className="d-flex">
                  <button className="btn btn-success hide-small" onClick={(e) => handleAddToCart(e, props.product)}>Add To Cart</button>
                  <AddedToCartMessage wasAdded={wasAdded} short={true} />
               </div>
            </div>
         </div>
         <div className="show-small">
            <p className="">{desc} <span><Link to={link}>Check this product!</Link></span></p>
            <p className="for-small-devices">USD ${priceUsd.toFixed(2)}</p>
            <p className="for-small-devices">CAD ${priceCad.toFixed(2)}</p>
            <div className="d-flex">
               <button className="btn btn-success" onClick={(e) => handleAddToCart(e, props.product)}>Add To Cart</button>
                  <AddedToCartMessage wasAdded={wasAdded} short={true} />
            </div>
         </div>
      </div>
   )
}

export default NewProduct
